import { render, staticRenderFns } from "./SongList.vue?vue&type=template&id=899d3f7a&scoped=true"
import script from "./SongList.vue?vue&type=script&lang=js"
export * from "./SongList.vue?vue&type=script&lang=js"
import style0 from "./SongList.vue?vue&type=style&index=0&id=899d3f7a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "899d3f7a",
  null
  
)

export default component.exports